import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ContentSpinnerComponent } from '@charlesschwab/as-ui-core';
import { CreateEditInstructionsViewMode, MutualFundInvestingService } from '../mutual-fund-investing.service';
import { Subscription } from 'rxjs';
import { CreateEditInstructionsModel, OpenInstructionModel } from './create-edit-instructions.model';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { AccountRecord } from '../../shared/components/account-search/account-search.model';
import { AccountSearchService } from '../../shared/components/account-search/account-search.service';
import { AccountNumberPipe } from '../../shared/pipes/account-number.pipe';
import { SymbolRecord } from '../../shared/components/symbol-search/symbol-search.model';
import { SymbolSearchService } from '../../shared/components/symbol-search/symbol-search.service';
import { messageConstants, statusConstants, tooltipConstants } from '../../shared/constants';
import {
  AmountTypeValues,
  DurationValues,
  FrequencyValues,
  TransactionTypeValues
} from '../../shared/constants/filter-constants';
import { ICreateUpdateInstructionResponse, IValidateInstructionResponse } from '../mutual-fund-investing.model';
import { IntegrationService } from '../../shared/services/integration.service';
import { SymbolSearchComponent } from '../../shared/components/symbol-search/symbol-search.component';
import { InstructionNotificationComponent } from '../../shared/components/instruction-notification/instruction-notification.component';
import { PreviewInstructionsComponent } from '../preview-instructions/preview-instructions.component';
import { NgClass } from '@angular/common';
import { AccountSearchComponent } from '../../shared/components/account-search/account-search.component';
import { CommonTooltipWithIconImageComponent } from '../view-instructions/components/common-tooltip-with-icon-image/common-tooltip-with-icon-image.component';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSuffix } from '@angular/material/select';

@Component({
    selector: 'app-create-edit-instructions',
    templateUrl: './create-edit-instructions.component.html',
    styleUrls: ['./create-edit-instructions.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, InstructionNotificationComponent, NgClass, AccountSearchComponent, CommonTooltipWithIconImageComponent, SymbolSearchComponent, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, PreviewInstructionsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CreateEditInstructionsComponent implements OnInit, OnDestroy {
  @ViewChild(ContentSpinnerComponent)
  SchSpinnerComponent?: ContentSpinnerComponent;
  isModalOpen = false;
  modelHeading: string;
  viewMode: string;
  instructionsData: CreateEditInstructionsModel;
  instructionsDataCopy: CreateEditInstructionsModel = null;
  instructionsDataClean: SymbolRecord = null;
  private createEditModal: Subscription;
  showEndDate: boolean;
  instructionsForm: FormGroup;
  startAtDate: Date;
  endDateMin: Date;
  isError: boolean;
  @ViewChild(SymbolSearchComponent) symbolSearchComponent!: any;
  previewContainer: HTMLElement;
  isCancelOrStopInstructionNow: boolean = false;
  frequencySource = [
    { label: 'Weekly', value: 'Weekly' },
    { label: 'Every other week', value: 'Every other week' },
    { label: 'Twice a month', value: 'Twice a month' },
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Every 3 months', value: 'Every 3 months' },
    { label: 'Every 6 months', value: 'Every 6 months' },
    { label: 'Annually', value: 'Annually' }
  ];
  daysSource = [
    '1st',
    '2nd',
    '3rd',
    '4th',
    '5th',
    '6th',
    '7th',
    '8th',
    '9th',
    '10th',
    '11th',
    '12th',
    '13th',
    '14th',
    '15th',
    '16th',
    '17th',
    '18th',
    '19th',
    '20th',
    '21st',
    '22nd',
    '23rd',
    '24th',
    '25th',
    '26th',
    '27th',
    '28th',
    '29th',
    '30th',
    '31st'
  ];
  startDateErrorMessage: string;
  startDateHasError: boolean;
  endDateErrorMessage: string;
  endDateHasError: boolean;
  disableAutoFormat = true;
  loading: boolean;
  selectedAccountWithName: string;
  selectedAccountDescription: string;
  selectedAccountName: string;
  selectedAccountType: string;
  selectedAccount: string;
  selectedSymbol: string;
  securityName: string;
  selectedSymbolName: string;
  accountNumberPipe = new AccountNumberPipe();
  symbolHasError: boolean;
  symbolErrorMessage: string;
  accountErrorMessage: string;
  accountHasError: boolean;
  instructionStatus: string;
  startDateLabel = 'Start Date';
  stopDateLabel = 'Stop date';
  isExistingInstruction: boolean;
  defaultModalHeading = 'Create automatic mutual fund instruction';
  existingInstruction: any;
  private stopInstructionSub: Subscription;
  private deleteInstructionSub: Subscription;
  isDurationRunUntilStopped: boolean;
  isDurationStopOnSelectedDate: boolean;
  dayToExecuteLabel: string;
  dayToExecuteErrorMessage: string;
  dayToExecuteHasError: boolean;
  transactionFee: string;
  mutualFundTooltipText: string;
  frequencyTooltipText: string;
  tooltip: any;
  displayAmount: string = '';
  printWindow: any;
  isStartDateButtonDisabled: boolean = false;
  isEndDateButtonDisabled: boolean = false;

  @ViewChild(InstructionNotificationComponent) instructionNotificationComponent: InstructionNotificationComponent;
  @ViewChild(PreviewInstructionsComponent) previewInstructionsComponent: PreviewInstructionsComponent;

  constructor(
    private mfInvestingService: MutualFundInvestingService,
    private symbolSearchService: SymbolSearchService,
    private accountSearchService: AccountSearchService,
    private integrationService: IntegrationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.modelHeading = this.defaultModalHeading;
    this.startAtDate = moment().add(1, 'days').toDate();
    this.endDateMin = moment().add(1, 'days').toDate();
    this.instructionsForm = new FormGroup({
      account: new FormControl('', Validators.required),
      accountName: new FormControl(''),
      accountDescription: new FormControl(''),
      accountType: new FormControl(''),
      transactionType: new FormControl('', Validators.required),
      amountType: new FormControl('', Validators.required),
      frequency: new FormControl('', Validators.required),
      symbol: new FormControl('', Validators.required),
      startDate: new FormControl('', Validators.required),
      amount: new FormControl('', Validators.required),
      duration: new FormControl('', Validators.required),
      endDate: new FormControl(''),
      accountControlNumber: new FormControl(''),
      discretionaryInd: new FormControl(''),
      solicitedInd: new FormControl(''),
      itemIssueId: new FormControl(''),
      status: new FormControl(''),
      restartDate: new FormControl(''),
      instructionContext: new FormControl(''),
      clndAuditIntgCntlNr: new FormControl(''),
      dayToExecute: new FormControl('', Validators.required),
      dayToExecute2: new FormControl('')
    });
    this.createEditModal = this.mfInvestingService.createEditModal$.subscribe((instruction) => {
      this.openModal(instruction);
    });
    this.stopInstructionSub = this.mfInvestingService.stopInstruction$.subscribe((instruction) => {
      this.stopInstruction(instruction);
    });
    this.deleteInstructionSub = this.mfInvestingService.deleteInstruction$.subscribe((instruction) => {
      this.deleteInstruction(instruction);
    });
    this.mutualFundTooltipText = tooltipConstants.mutualFundTooltipMsg;
    this.frequencyTooltipText = tooltipConstants.frequencyTootipMsg;
  }

  ngOnDestroy(): void {
    this.createEditModal.unsubscribe();
    this.stopInstructionSub.unsubscribe();
    this.deleteInstructionSub.unsubscribe();
  }

  openModal(model: OpenInstructionModel): void {
    if (model) {
      this.viewMode = model.mode ?? CreateEditInstructionsViewMode.EDIT_INSTRUCTION;
      this.instructionsData = model.instruction;
      this.modelHeading = 'Automatic mutual fund instruction';
      if (this.viewMode === CreateEditInstructionsViewMode.EDIT_INSTRUCTION) {
        this.modelHeading = 'Edit automatic mutual fund instruction';
        if (this.instructionsData.status === statusConstants.active) {
          this.startDateLabel = 'Original start date';
          this.setEndDateMinBasedOnStartDate(this.instructionsData.startDate);
        } else if (this.instructionsData.status === statusConstants.pending) {
          this.startDateLabel = 'Start Date';
          this.setEndDateMinBasedOnStartDate(this.instructionsData.startDate);
        } else if (
          this.instructionsData.status === statusConstants.stopped ||
          this.instructionsData.status === statusConstants.restarted
        ) {
          this.startDateLabel = 'Restart Date';
          this.setEndDateMinBasedOnStartDate(this.instructionsData.restartDate ?? null);
        }

        this.isExistingInstruction = true;
        setTimeout(() => {
          this.populateAndDisableAccountSymbolFields(this.instructionsData);
        }, 100);
      } else if (this.viewMode == CreateEditInstructionsViewMode.VIEW_INSTRUCTION) {
        setTimeout(() => {
          this.previewInstructionsComponent.loadInstructionData();
        }, 100);
      }
    } else {
      this.modelHeading = this.defaultModalHeading;
      this.instructionsForm.reset();
      this.instructionsForm.controls.frequency.patchValue('Monthly');
      this.instructionsForm.controls.discretionaryInd.setValue(true);
      this.instructionsData = null;
      this.selectedAccountWithName = null;
      this.selectedAccount = null;
      this.selectedSymbol = null;
      this.selectedSymbolName = null;
      this.securityName = null;
      this.checkAmountType(true);
      this.showEndDate = false;
      this.isDurationRunUntilStopped = false;
      this.isDurationStopOnSelectedDate = false;
      this.viewMode = CreateEditInstructionsViewMode.CREATE_INSTRUCTION;
      this.startDateHasError = false;
      this.startDateErrorMessage = '';
      this.endDateHasError = false;
      this.endDateErrorMessage = '';
      this.symbolErrorMessage = '';
      this.symbolHasError = false;
      this.accountHasError = false;
      this.accountErrorMessage = '';
      this.startDateLabel = 'Start Date';
      this.stopDateLabel = 'Stop date';
      this.dayToExecuteErrorMessage = '';
      this.dayToExecuteHasError = false;
      this.transactionFee = '';
    }
    this.isError = false;
    this.isModalOpen = true;

    let modalElement = document.getElementById('create-new-modal');
    //@ts-ignore
    modalElement.showModal();

    this.instructionStatus = '';
    if (this.viewMode !== CreateEditInstructionsViewMode.VIEW_INSTRUCTION) {
      this.setValidationsOnDateFields();
    }
    this.dayToExecuteLabel = messageConstants.executeTransactionOn + ':';

    this.resetModalInputFields();
  }

  afterCloseInstructionModal(event, viewMode: string): void {
    event.preventDefault();

    this.instructionNotificationComponent.clearNotification();

    if (viewMode === 'SUBMITTED' || this.isCancelOrStopInstructionNow) {
      this.mfInvestingService.refreshMutualFundInstructions();
      this.isCancelOrStopInstructionNow = false;
    }

    this.clearPopulatedInstructionFields();

    this.resetModalInputFields();
    this.resetDurationFields();
    this.resetTransactionTypeFields();

    this.isModalOpen = false;
    this.existingInstruction = null;
  }

  closeModal(event, viewMode: string): void {
    event.preventDefault();

    const symbolElem = document.getElementById('symbol-container');
    symbolElem.classList.remove('sdps-has-error');

    let modalElement = document.getElementById('create-new-modal');
    //@ts-ignore
    modalElement.hideModal();
  }

  resetModalInputFields(): void {
    const parentElement = document.getElementById('create-edit-instructions-container') as HTMLElement;
    const accountInput = parentElement.getElementsByClassName('client-search')[0] as HTMLInputElement;
    if (accountInput) {
      accountInput.disabled = false;
    }

    const symbolInput = parentElement.getElementsByClassName('client-search')[1] as HTMLInputElement;
    if (symbolInput) {
      symbolInput.disabled = false;
    }

    const startDateElm = document.getElementById('calendar-startDate') as HTMLInputElement;
    if (startDateElm) {
      startDateElm.disabled = false;
      startDateElm.value = '';
      this.instructionsForm.controls.startDate.setValue(null);
    }
    const startDateButton = document.getElementById('calendarIcon-startDate') as HTMLButtonElement;
    if (startDateButton) {
      startDateButton.disabled = false;
      this.isStartDateButtonDisabled = false;
    }

    const endDateElm = document.getElementById('calendar-endDate') as HTMLInputElement;
    if (endDateElm) {
      endDateElm.disabled = false;
      endDateElm.value = '';
      this.instructionsForm.controls.endDate.setValue(null);
    }
    const endDateButton = document.getElementById('calendarIcon-endDate') as HTMLButtonElement;
    if (endDateButton) {
      endDateButton.disabled = false;
      this.isEndDateButtonDisabled = false;
    }
  }

  resetDurationFields(): void {
    this.isDurationStopOnSelectedDate = false;
    this.isDurationRunUntilStopped = false;
    this.showEndDate = false;

    this.instructionsForm.controls.duration.setValue(null);
    this.instructionsForm.controls.endDate.setValue(null);

    this.instructionsForm.controls.endDate.clearValidators();
    this.instructionsForm.controls.endDate.updateValueAndValidity();

    this.endDateHasError = false;
    this.endDateErrorMessage = '';

    // Trigger change detection to update the view
    this.cdr.detectChanges();
  }

  resetTransactionTypeFields(): void {
    const discretionaryCheckbox = document.getElementById('sdps-discretionary-checkbox-id') as HTMLInputElement;
    const solicitedCheckbox = document.getElementById('sdps-solicited-checkbox-id') as HTMLInputElement;
    if (discretionaryCheckbox) {
      discretionaryCheckbox.checked = true;
      this.instructionsForm.controls.discretionaryInd.setValue(true);
    }
    if (solicitedCheckbox) {
      solicitedCheckbox.checked = false;
      this.instructionsForm.controls.solicitedInd.setValue(false);
    }

    const transactionTypeSelect = document.getElementById('transaction-type-select-id') as HTMLSelectElement;
    if (transactionTypeSelect) {
      transactionTypeSelect.value = 'empty';
      this.instructionsForm.controls.transactionType.setValue(null);
    }
  }

  previewInstruction(): void {
    if (this.instructionsForm.valid) {
      this.showSpinner();

      if (this.instructionsData) {
        const isRestarted = this.instructionsData.isRestarted;
        let restartDate = this.instructionsData.restartDate;
        let startDate = this.instructionsData.startDate;
        let endDate = this.instructionsData.endDate;
        if (
          this.instructionsData.status &&
          (this.instructionsData.status == statusConstants.stopped ||
            this.instructionsData.status == statusConstants.restarted)
        ) {
          if (this.instructionsData.startDate != this.instructionsForm.value.startDate) {
            restartDate = moment(this.instructionsForm.controls.startDate.value).format("MM/DD/YYYY");
            startDate = this.instructionsData.startDate;
          }
        }

        this.formatDateForInstructionsForm();
        this.instructionsData = this.instructionsForm.value;
        this.instructionsData.isRestarted = isRestarted;
        if (this.instructionsData.status != statusConstants.pending) {
          this.instructionsData.startDate = startDate;
        }
        this.instructionsData.restartDate = restartDate;

        if (this.instructionsData.status && this.instructionsData.status == statusConstants.restarted) {
          this.instructionsData.endDate = endDate;
        }
      } else {
        this.formatDateForInstructionsForm();
        this.instructionsData = this.instructionsForm.value;
        this.instructionsData.isRestarted = false;
      }

      this.instructionsData.securityName = this.securityName;

      if (this.instructionsData.transactionType === TransactionTypeValues.Buy) {
        this.instructionsData.amountType = AmountTypeValues.dollars;
      }

      this.validateInstruction();
      this.hideSpinner();
    }
  }

  private formatDateForInstructionsForm() {
    this.instructionsForm.controls.startDate.setValue(moment(this.instructionsForm.controls.startDate.value).format("MM/DD/YYYY"));
    if(moment(this.instructionsForm.controls.endDate.value, "MM/DD/YYYY", true).isValid()) {
      this.instructionsForm.controls.endDate.setValue(moment(this.instructionsForm.controls.endDate.value).format("MM/DD/YYYY"));
    }
  }

  submitInstruction(): void {
    this.showSpinner();
    this.isError = false;
    const instructionDataCopy = this.prepareInstructionData();
    this.mfInvestingService.createUpdateInstruction(instructionDataCopy).subscribe(
      (response: ICreateUpdateInstructionResponse) => {
        this.hideSpinner();
        const updatedSuccessfully = response.data.attributes.createdSuccesfullyInd;
        if (updatedSuccessfully) {
          this.mfInvestingService.showHideInstructionNotification({
            notificationType: 'confirmation',
            messages: [messageConstants.successfullyCreatedUpdated]
          });
          this.viewMode = CreateEditInstructionsViewMode.SUBMITTED_INSTRUCTION;
        } else {
          this.isError = true;
          this.mfInvestingService.showHideInstructionNotification({
            notificationType: 'error',
            messages: [messageConstants.errorCreatingUpdating]
          });
        }
      },
      (error) => {
        this.isError = true;
        this.mfInvestingService.showHideInstructionNotification({
          notificationType: 'error',
          messages: [messageConstants.errorCreatingUpdating]
        });
        this.hideSpinner();
      }
    );
  }

  createAnotherInstruction(instruction: CreateEditInstructionsModel): void {
    const openModel: OpenInstructionModel = {
      instruction: instruction,
      mode: CreateEditInstructionsViewMode.CREATE_INSTRUCTION
    };
    this.mfInvestingService.refreshMutualFundInstructions();
    this.instructionsForm.reset();
    this.populateInstructionDataForAnother(instruction);
    this.mfInvestingService.showHideInstructionNotification();
    this.mfInvestingService.openCreateEditInstructions(openModel);
    this.modelHeading = 'Create automatic mutual fund instruction';
    this.resetTransactionTypeFields();
    setTimeout(() => {
      this.resetDurationFields();
      const parentElement = document.getElementById('create-edit-instructions-container') as HTMLElement;
      const accountInput = parentElement.getElementsByClassName('client-search')[0] as HTMLInputElement;
      const symbolInput = parentElement.getElementsByClassName('client-search')[1] as HTMLInputElement;
      if (accountInput && symbolInput) {
        this.resetModalInputFields();
        this.symbolSearchComponent.clearSearch();
      }
    }, 500);
  }

  populateInstructionDataForAnother(instruction: CreateEditInstructionsModel): void {
    this.instructionsForm.patchValue({
      account: this.selectedAccount ? this.selectedAccount : instruction.account,
      accountControlNumber: '',
      symbol: this.selectedSymbol ? this.selectedSymbol : instruction.symbol,
      transactionType: null,
      amountType: null,
      amount: null,
      frequency: 'Monthly',
      startDate: null,
      duration: null,
      endDate: null,
      discretionaryInd: false,
      solicitedInd: false,
      itemIssueId: null,
      status: '',
      restartDate: null,
      instructionContext: null,
      clndAuditIntgCntlNr: null,
      dayToExecute: null,
      dayToExecute2: null
    });
  }

  prepareInstructionData(): CreateEditInstructionsModel {
    const instruction = Object.assign({}, this.instructionsData);
    // formatting date for backend service
    if (this.instructionsData.restartDate) {
      instruction.restartDate = this.getDateInBackendFormat(new Date(this.instructionsData.restartDate));
    }
    if (this.instructionsData.startDate) {
      instruction.startDate = this.getDateInBackendFormat(new Date(this.instructionsData.startDate));
    }
    if (this.instructionsData.endDate) {
      instruction.endDate = this.getDateInBackendFormat(new Date(this.instructionsData.endDate));
      if (this.instructionsData.isRestarted) {
        instruction.restartDate = null;
        this.instructionsData.isRestarted = false;
      }
    }

    //if stop date has changed AND restart date exists AND is in the past THEN clear restart date
    if (this.instructionsDataClean.endDate != this.instructionsData.endDate) {
      if (this.instructionsData.restartDate) {
        let restartDateTime = new Date(this.instructionsData.restartDate);
        let todayDateTime = new Date();

        if (restartDateTime <= todayDateTime) {
          instruction.restartDate = null;
          this.instructionsData.isRestarted = false;
        }
      }
    }

    if (instruction.status && instruction.status.length > 1) {
      instruction.isUpdate = true;
    } else {
      instruction.isUpdate = false;
    }
    if (instruction.status == null || instruction.status === undefined) {
      instruction.status = '';
    }
    if (instruction.amountType === 'Dollars') {
      instruction.amount = parseFloat(instruction.amount.toString().replace('$', '').replaceAll(',', ''));
      this.instructionsData.amount = instruction.amount;
    }
    return instruction;
  }

  discretionaryChanged(event): void {
    this.instructionsForm.controls.discretionaryInd.setValue(event.currentTarget.checked);
    this.clearHardEditNotificationBanner();
  }

  solicitedChanged(event): void {
    this.instructionsForm.controls.solicitedInd.setValue(event.currentTarget.checked);
    this.clearHardEditNotificationBanner();
  }

  amountChanged(): void {
    var amountType = this.instructionsForm.controls.amountType.value;
    var amount = this.instructionsForm.controls.amount.value;

    if (amountType == AmountTypeValues.dollars) {
      amount =
        amount.indexOf('.') >= 0 ? amount.substr(0, amount.indexOf('.')) + amount.substr(amount.indexOf('.'), 3) : amount;
    } else {
      amount =
        amount.indexOf('.') >= 0 ? amount.substr(0, amount.indexOf('.')) + amount.substr(amount.indexOf('.'), 4) : amount;
    }
    this.instructionsForm.controls.amount.setValue(amount);

    this.clearHardEditNotificationBanner();
  }

  isEditAndNoChangesHaveNotBeenMade(): boolean {
    if (
      this.instructionsForm &&
      this.instructionsDataCopy &&
      this.viewMode === CreateEditInstructionsViewMode.EDIT_INSTRUCTION
    ) {
      return (
        Object.entries(this.instructionsForm.value).sort().toString() ===
        Object.entries(this.instructionsDataCopy).sort().toString()
      );
    }
    return false;
  }

  checkIfFormIsValid(): boolean {
    if (this?.instructionNotificationComponent?.isNoTradeDataAccessNotificationActive()) {
      return false;
    } else {
      const v1 = this.instructionsForm.value.dayToExecute;
      const v2 = this.instructionsForm.value.dayToExecute2;
      if (
        this.instructionsForm.value.frequency === FrequencyValues[0] ||
        this.instructionsForm.value.frequency === FrequencyValues[1]
      ) {
        if (
          this.instructionsForm.value.dayToExecute === 'Saturday' ||
          this.instructionsForm.value.dayToExecute === 'Sunday'
        ) {
          return false;
        }
      }
      if (
        !v1 ||
        v1.length === 0 ||
        (this.instructionsForm.value.frequency === FrequencyValues[2] && (!v2 || v2.length === 0))
      ) {
        return false;
      }
      if (
        this.instructionsForm.invalid ||
        (this.startDateErrorMessage && this.startDateErrorMessage.length > 0) ||
        (this.endDateErrorMessage && this.endDateErrorMessage.length > 0) ||
        this.isEditAndNoChangesHaveNotBeenMade() ||
        (this.dayToExecuteErrorMessage && this.dayToExecuteErrorMessage.length > 0) ||
        this.accountHasError
      ) {
        return false;
      }
      if (this.isExistingInstruction) {
        return !this.checkIfUserUpdatedExistingInstruction(this.existingInstruction, this.instructionsForm.value);
      }
      return true;
    }
  }

  showSpinner(): void {
    if (this.SchSpinnerComponent) {
      this.SchSpinnerComponent.show();
    }
  }

  hideSpinner(): void {
    if (this.SchSpinnerComponent) {
      this.SchSpinnerComponent.hide();
    }
  }

  goBack(event): void {
    event.preventDefault();
    this.viewMode = CreateEditInstructionsViewMode.CREATE_INSTRUCTION;
    this.disableAutoFormat = false;
    this.mfInvestingService.showHideInstructionNotification();
    this.populateInstructionsForm(this.instructionsData);
  }

  updateTransactionType(event): void {
    const transactionType = event.target.value;
    if (transactionType) {
      this.instructionsForm.controls.transactionType.setValue(transactionType);
      this.enableDisableAmountType(transactionType);
    }
    this.clearHardEditNotificationBanner();
  }

  formatAmount(): void {
    const amount = this.instructionsForm.controls.amount.value;
    if (!amount) {
      this.instructionsForm.controls.amount.setValue('');
      this.displayAmount = '';
      return;
    }
    let amt = amount.toString().replace('$', '').replaceAll(',', '');
    if (this.instructionsForm.controls.amountType.value === 'Dollars') {
      const formattedValue = parseFloat(amt)
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      if (amt && amt.length > 0 && amt[0] !== '$') {
        amt = '$' + formattedValue;
      } else {
        amt = formattedValue;
      }
    } else {
      const formattedValue = parseFloat(amt)
        .toFixed(3)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      amt = formattedValue;
    }
    this.displayAmount = amt;
  }

  focusAmount(): void {
    const amt = this.instructionsForm.controls.amount.value;
    let newamt = '';
    for (let i = 0; i < amt.length; i++) {
      if (amt[i] === '.' || (amt[i] >= '0' && amt[i] <= '9')) {
        newamt += amt[i];
      }
    }
    this.instructionsForm.controls.amount.setValue(newamt);
  }

  checkAmountType(enableFlag: boolean): void {
    const ctrl = this.instructionsForm.get('amountType');
    enableFlag ? ctrl.enable() : ctrl.disable();
  }

  updateAmountType(event): void {
    const value = event.target.value;

    if (value) {
      this.instructionsForm.controls.amountType.setValue(value);
      this.validateAmountField(value);
    }

    this.formatAmount();

    this.clearHardEditNotificationBanner();
  }

  updateFrequency(event): void {
    const frequencyValue = event.target.value;
    if (frequencyValue) {
      this.instructionsForm.controls.frequency.setValue(frequencyValue);
      this.checkStartDateBasedOnFrequency(true);
      this.clearDayToExecuteBasedOnFrequency(frequencyValue);
      setTimeout(() => {
        this.updateSecondDayToExecute();
      }, 100);
    }
    if (frequencyValue === FrequencyValues[2]) {
      this.instructionsForm.controls['dayToExecute2'].setValidators([Validators.required]);
      this.instructionsForm.controls['dayToExecute2'].updateValueAndValidity();
    } else {
      this.instructionsForm.controls['dayToExecute2'].clearValidators();
      this.instructionsForm.controls['dayToExecute2'].updateValueAndValidity();
    }
    this.clearHardEditNotificationBanner();
  }

  updateDuration(event): void {
    const duration = event.target.value;
    const endDate = this.instructionsForm.controls.endDate.value;
    if (duration) {
      this.instructionsForm.controls.duration.setValue(duration);

      if (duration === DurationValues.runUntilStopped) {
        this.isDurationRunUntilStopped = true;
        this.isDurationStopOnSelectedDate = false;
      } else if (duration === DurationValues.stopOnSelectedDate) {
        this.isDurationRunUntilStopped = false;
        this.isDurationStopOnSelectedDate = true;
      }

      this.showHideEndDate(duration, endDate);
      this.instructionsForm.controls['endDate'].updateValueAndValidity();
    }
    this.clearHardEditNotificationBanner();
  }

  setEndDateMinBasedOnStartDate(startDate: string): void {
    if (startDate == null || moment(startDate, 'MM/DD/YYYY').isBefore(moment.now())) {
      this.endDateMin = moment().add(1, 'days').toDate();
    } else {
      this.endDateMin = moment(moment(startDate, 'MM/DD/YYYY')).add(1, 'days').toDate();
    }
  }

  // Start Date Validation
  checkStartDateBasedOnFrequency(isFrequencyChanged?: boolean): void {
    const startDate = this.instructionsForm.controls.startDate.value;
    const frequency = this.instructionsForm.controls.frequency.value;

    this.setEndDateMinBasedOnStartDate(startDate);

    this.validateEndDateBasedOnStartDate();

    this.disableAutoFormat = true;
    const startDateElm = document.getElementById('calendar-startDate') as HTMLInputElement;
    if (startDateElm.disabled === false) {
      this.validateStartDateForFrequency(startDate);
    }
    this.clearHardEditNotificationBanner();
  }

  private dayToExecuteChanged(event): void {
    this.clearHardEditNotificationBanner();
  }

  private validateStartDateForFrequency(startDate: string): void {
    if (!this.checkIfValidDate(startDate) && startDate) {
      this.startDateErrorMessage = 'Please enter a date in MM/DD/YYYY format';
      this.startDateHasError = true;
    } else {
      this.startDateErrorMessage = '';
      this.startDateHasError = false;
      this.updateDayToExecute(startDate);
      if ((!startDate || startDate.length === 0) && this.instructionsForm.get('startDate').invalid) {
        this.startDateErrorMessage = 'You must enter a start date to continue';
        this.startDateHasError = true;
      } else if (this.checkIfPastDate(startDate)) {
        this.startDateErrorMessage = 'Your start date must be in the future';
        this.startDateHasError = true;
      }
    }
  }

  private validateStartDate(date: string): void {
    if (!this.checkIfValidDate(date)) {
      this.startDateErrorMessage = 'Please enter a date in MM/DD/YYYY format';
      this.startDateHasError = true;
    } else {
      if (this.checkIfPastDate(date)) {
        this.startDateErrorMessage = 'Your start date must be in the future';
        this.startDateHasError = true;
      } else {
        this.startDateErrorMessage = '';
        this.startDateHasError = false;
      }
    }
  }

  // method to see if passed date is in correct format
  private checkIfValidDate(date: string): boolean {
    const calendarDate = moment(date, 'MM/DD/YYYY', true);
    if (calendarDate.isValid()) {
      return true;
    }
    return false;
  }

  private checkIfPastDate(date: string): boolean {
    const selectedDate = moment(date, 'MM/DD/YYYY', true);
    const currDate = moment();
    if (selectedDate.isSameOrBefore(currDate)) {
      return true;
    }
    return false;
  }

  // Stop Date Validation
  checkEndDateForErrors(): void {
    if (this.instructionsForm.controls.duration.value) {
      const endDate = this.instructionsForm.controls.endDate.value;
      this.disableAutoFormat = true;
      this.validateEndDate(endDate);
    }
    this.clearHardEditNotificationBanner();
  }

  private validateEndDate(endDate: string): void {
    if ((!endDate || endDate.length === 0) && this.instructionsForm.get('endDate').invalid) {
      this.endDateErrorMessage = 'You must enter a stop date to continue';
      this.endDateHasError = true;
    } else if (endDate && !this.checkIfValidDate(endDate)) {
      this.invalidEndDateFormatMsg();
    } else if (this.instructionsForm.controls.startDate.value) {
      this.validateEndDateBasedOnStartDate();
    } else {
      this.endDateErrorMessage = '';
      this.endDateHasError = false;
    }
  }

  private invalidEndDateFormatMsg(): void {
    this.endDateErrorMessage = 'Please enter a date in MM/DD/YYYY format';
    this.endDateHasError = true;
  }

  private validateEndDateBasedOnStartDate(): void {
    const endDate = document.getElementById('calendar-endDate') as HTMLInputElement;
    if (this.instructionsForm.controls.endDate.value != null || '') {
      if (
        moment(moment(this.instructionsForm.controls.endDate.value, 'MM/DD/YYYY')).isBefore(
          moment(this.endDateMin),
          'day'
        ) &&
        endDate.disabled === false
      ) {
        this.endDateErrorMessage = 'Your stop date must be after your start date';
        this.endDateHasError = true;
      } else {
        this.endDateErrorMessage = '';
        this.endDateHasError = false;
      }
    }
  }

  accountSelected(account: AccountRecord): void {
    this.setAccountField(account);
    // clear symbol field whenever a new account is selected or cleared or changes
    this.clearSymbolField();
    this.startDateLabel = 'Start Date';
    if (this.existingInstruction) {
      this.clearPopulatedInstructionFields();
      if (this.startDateHasError) {
        this.startDateErrorMessage = '';
        this.startDateHasError = false;
      }
    }
  }

  symbolSelected(symbolRecord: SymbolRecord): void {
    if (symbolRecord && symbolRecord.fundSymbol) {
      this.instructionsDataClean = Object.assign({}, symbolRecord);

      this.selectedSymbol = symbolRecord.fundSymbol;
      this.securityName = symbolRecord.fundSymbol + ' - ' + symbolRecord.fundName;
      this.selectedSymbolName = symbolRecord.fundName;
      this.instructionsForm.controls.symbol.setValue(symbolRecord.fundSymbol);
      this.instructionsForm.controls.itemIssueId.setValue(symbolRecord.itemIssueId);
      if (symbolRecord.accountControlNumber !== null && symbolRecord.accountControlNumber !== undefined) {
        this.instructionsForm.controls.accountControlNumber.setValue(symbolRecord.accountControlNumber);
      }
      if (symbolRecord.instructionContext !== null && symbolRecord.instructionContext !== undefined) {
        this.instructionsForm.controls.instructionContext.setValue(symbolRecord.instructionContext);
      }
      if (symbolRecord.clndAuditIntgCntlNr !== null && symbolRecord.clndAuditIntgCntlNr !== undefined) {
        this.instructionsForm.controls.clndAuditIntgCntlNr.setValue(symbolRecord.clndAuditIntgCntlNr);
      }

      this.symbolErrorMessage = '';
      this.symbolHasError = false;
      if (this.viewMode !== CreateEditInstructionsViewMode.EDIT_INSTRUCTION) {
        if (symbolRecord.status === statusConstants.active || symbolRecord.status === statusConstants.pending) {
          this.populateExistingInstruction(symbolRecord);
          this.isExistingInstruction = true;
          this.instructionStatus = statusConstants.active;
          this.startDateLabel = symbolRecord.status === statusConstants.active ? 'Original start date' : 'Start Date';
        } else if (symbolRecord.status === statusConstants.stopped) {
          this.populateExistingInstruction(symbolRecord);
          this.isExistingInstruction = true;
          this.instructionStatus = statusConstants.stopped;
          this.startDateLabel = 'Restart Date';
        } else if (symbolRecord.status === statusConstants.restarted) {
          this.populateExistingInstruction(symbolRecord);
          this.isExistingInstruction = true;
          this.instructionStatus = statusConstants.restarted;
          this.startDateLabel = 'Restart Date';
        } else {
          this.instructionsData = null;
          this.isExistingInstruction = false;
          this.instructionStatus = '';
          this.clearPopulatedInstructionFields();
          this.startDateLabel = 'Start Date';
        }
      } else {
        this.instructionsDataCopy = Object.assign({}, this.instructionsForm.value);
      }
    } else {
      this.clearSymbolField();
      this.startDateLabel = 'Start Date';
      this.clearPopulatedInstructionFields();
      this.instructionsForm.controls.itemIssueId.setValue(null);
      this.instructionsForm.controls.accountControlNumber.setValue(null);
      this.setInvalidSymbolMsg();
      if (this.isExistingInstruction && this.startDateHasError) {
        this.validateStartDate(this.instructionsData.startDate);
      }
    }
    this.addRemoveErrorClassForSymbol();
    this.formatAmount();
  }
  showSymbolValidation(hasFundsAvailable: boolean): void {
    if (!hasFundsAvailable) {
      this.symbolErrorMessage = 'No eligible MF positions available for this account';
      this.instructionsForm.controls.symbol.setValue(null);
      this.symbolHasError = true;
    } else {
      this.symbolErrorMessage = '';
      this.symbolHasError = false;
    }
    this.addRemoveErrorClassForSymbol();
  }
  invalidFundSelected(): void {
    this.setInvalidSymbolMsg();
    this.instructionsForm.controls.symbol.setValue(null);
    this.addRemoveErrorClassForSymbol();
  }
  checkIfSymbolIsBlank(symbolIsBlank: boolean): void {
    if (symbolIsBlank) {
      this.symbolErrorMessage = 'You must enter a symbol to continue';
      this.symbolHasError = true;
      this.addRemoveErrorClassForSymbol();
    } else {
      this.symbolErrorMessage = '';
      this.symbolHasError = false;
      this.addRemoveErrorClassForSymbol();
    }
  }

  private setInvalidSymbolMsg(): void {
    this.symbolErrorMessage = 'Please enter a valid symbol';
    this.symbolHasError = true;
  }

  private addRemoveErrorClassForSymbol(): void {
    const symbolElem = document.getElementById('symbol-container');
    if (this.symbolHasError) {
      symbolElem.classList.add('sdps-has-error');
    } else {
      symbolElem.classList.remove('sdps-has-error');
    }
  }

  showHideAccountRequired(): void {
    if (!this.selectedAccountWithName) {
      if (this.instructionNotificationComponent.isNoTradeDataAccessNotificationActive()) {
        this.mfInvestingService.showHideInstructionNotification();
      }

      this.accountErrorMessage = 'You must enter an account number to continue';
      this.accountHasError = true;
    } else {
      this.accountErrorMessage = '';
      this.accountHasError = false;
    }
  }

  showHideInvalidAccountMessage(isValid: boolean): void {
    if (!isValid) {
      this.accountErrorMessage = 'Please enter a valid account';
      this.accountHasError = true;
      this.clearSymbolField();
    } else {
      this.accountErrorMessage = '';
      this.accountHasError = false;
    }
  }

  private clearSymbolField(): void {
    this.selectedSymbol = null;
    this.instructionsForm.controls.symbol.setValue(null);
  }

  // Amount Validation
  isAmountBlank(): boolean {
    if (
      this.instructionsForm.controls['amount'].invalid &&
      (this.instructionsForm.controls['amount'].errors.dirty || this.instructionsForm.controls['amount'].touched) &&
      this.instructionsForm.controls['amount'].errors.required
    ) {
      return true;
    } else {
      return false;
    }
  }

  private setValidationsOnDateFields(): void {
    const dateFields = ['startDate', 'endDate'];
    dateFields.forEach((dateField) => {
      setTimeout(() => {
        const date: any = document.getElementById('calendar-' + dateField);
        if (date) {
          date.setAttribute('maxlength', '10');
          date.onkeypress = date.onpaste = this.checkDateInput;
        }
      }, 500);
    });
  }

  private checkDateInput(event): boolean {
    const char =
      event.type === 'keypress' ? String.fromCharCode(event.keyCode || event.which) : event.clipboardData.getData('Text');
    if (/[^0-9/]/gi.test(char)) {
      return false;
    }
  }

  private checkDigitsAfterDecimal(amount: string): number {
    if (amount) {
      const amountField = amount.toString();
      const decimalIndex = amountField ? amountField.indexOf('.') : -1;
      if (decimalIndex > -1) {
        return amountField.substr(decimalIndex + 1, amountField.length).length;
      }
    }
    return 0;
  }

  public validateAmountField(value: string): void {
    if (value === 'Dollars' && this.checkDigitsAfterDecimal(this.instructionsForm.controls.amount.value) > 2) {
      this.instructionsForm.controls.amount.setValue(null);
    }
  }

  private populateExistingInstruction(symbolRecord: SymbolRecord): void {
    this.symbolSearchService
      .getAvailableFundsForAccount({ accountId: this.selectedAccount, itemIssueId: symbolRecord.itemIssueId })
      .subscribe(
        (response) => {
          const existingInstruction: CreateEditInstructionsModel = response?.data?.attributes.elgibleInstructions[0];
          existingInstruction.accountControlNumber = response?.data?.attributes.accountControlNumber;
          if (existingInstruction) {
            //if restart date AND end date are populated AND both are in the past THEN end date is set to a blank string
            if (existingInstruction.endDate != null && existingInstruction.restartDate != null) {
              let endDateTime = new Date(existingInstruction.endDate);
              let restartDateTime = new Date(existingInstruction.restartDate);
              let todayDateTime = new Date();

              if (endDateTime <= todayDateTime && restartDateTime <= todayDateTime) {
                existingInstruction.endDate = existingInstruction.endDate;
                existingInstruction.duration = DurationValues.runUntilStopped;
                existingInstruction.isRestarted = true;
              }
            }

            this.instructionsData = existingInstruction;
            this.instructionsData.status = symbolRecord.status;
            this.populateInstructionsForm(this.instructionsData);
            this.formatAmount();

            if (!this.instructionNotificationComponent.isNoTradeDataAccessNotificationActive()) {
              setTimeout(() => {
                this.mfInvestingService.showHideInstructionNotification({
                  notificationType: 'warning',
                  messages: [
                    'There is already an instruction created for this account & symbol. You may only have one instruction per Mutual Fund position in an account. We have populated the details of this instruction below. Please edit this currently ' +
                      this.instructionStatus +
                      ' instruction to continue.'
                  ],
                  isInstructionAlreadyExistsWarning: true
                });
              }, 100);
            }
          }
        },
        (error) => {}
      );
  }

  private populateDatesForEditInstructions(instruction: CreateEditInstructionsModel): void {
    const startDate = document.getElementById('calendar-startDate') as HTMLInputElement;
    const endDate = document.getElementById('calendar-endDate') as HTMLInputElement;
    if (instruction.startDate && startDate) {
      startDate.value = instruction.startDate;
      this.instructionsForm.controls.startDate.setValue(moment(instruction.startDate));
      this.instructionsForm.controls.startDate.setErrors(null);
    }
    if (instruction.endDate && endDate) {
      endDate.value = instruction.endDate;
      this.instructionsForm.controls.endDate.setValue(moment(instruction.endDate));
      this.instructionsForm.controls.endDate.setErrors(null);
    }
  }

  private clearPopulatedInstructionFields(): void {
    if (!this.instructionNotificationComponent.isNoTradeDataAccessNotificationActive()) {
      this.mfInvestingService.showHideInstructionNotification();
    }

    if (!this.instructionsData) {
      const type = this.instructionsForm.controls['transactionType'].value;
      type === TransactionTypeValues.Buy ? this.checkAmountType(false) : this.checkAmountType(true);
    } else {
      this.checkAmountType(true);
    }
    this.existingInstruction = null;
    if (this.instructionsData) {
      this.instructionsData.transactionType = null;
      this.instructionsData.amountType = null;
      this.instructionsData.amount = null;
      this.instructionsData.frequency = null;
      this.instructionsData.startDate = null;
      this.instructionsData.duration = null;
      this.instructionsData.endDate = null;
      this.instructionsData.accountControlNumber = null;
      this.instructionsData.itemIssueId = null;
      this.instructionsData.dayToExecute = null;
      this.instructionsData.dayToExecute2 = null;
      this.instructionsData.status = null;
      this.instructionsForm.patchValue({
        transactionType: this.instructionsData.transactionType,
        amountType: this.instructionsData.amountType,
        amount: this.instructionsData.amount,
        frequency: this.instructionsData.frequency,
        startDate: this.instructionsData.startDate,
        duration: this.instructionsData.duration,
        endDate: this.instructionsData.endDate,
        accountControlNumber: this.instructionsData.accountControlNumber,
        itemIssueId: this.instructionsData.itemIssueId,
        dayToExecute: this.instructionsData.dayToExecute,
        dayToExecute2: this.instructionsData.dayToExecute2,
        status: this.instructionsData.status
      });
      const startDate = document.getElementById('calendar-startDate') as HTMLInputElement;
      const startDateButton = document.getElementById('calendarIcon-startDate') as HTMLButtonElement;
      if(startDate) {
        startDate.value = null;
        startDate.disabled = false;
      }
      if(startDateButton) {
        startDateButton.disabled = false;
        this.isStartDateButtonDisabled = false;
      }
      this.startDateHasError = false;
      this.startDateErrorMessage = '';
      const endDate = document.getElementById('calendar-endDate') as HTMLInputElement;
      if (endDate) {
        endDate.value = null;
      }
      if (this.instructionsData.duration === null) {
        this.isDurationRunUntilStopped = false;
        this.showEndDate = false;
        this.isDurationStopOnSelectedDate = false;
        this.updateDurationFields(false);
      }
    }
  }

  private checkIfUserUpdatedExistingInstruction(
    existingInstruction: CreateEditInstructionsModel,
    changedInstruction: CreateEditInstructionsModel
  ): boolean {
    if (existingInstruction && changedInstruction) {
      const obj1Length: number = Object.keys(existingInstruction).length;
      const obj2Length: number = Object.keys(changedInstruction).length;
      if (obj1Length === obj2Length) {
        return Object.keys(existingInstruction).every(
          (key) => changedInstruction.hasOwnProperty(key) && changedInstruction[key] === existingInstruction[key]
        );
      }
    }
    return false;
  }

  private showHideEndDate(duration: string, endDate: string): void {
    if (duration === DurationValues.runUntilStopped) {
      this.showEndDate = false;
      this.instructionsForm.controls.endDate.setValue(null);
      this.instructionsForm.controls['endDate'].clearValidators();
      this.endDateHasError = false;
      this.endDateErrorMessage = '';
    } else {
      this.showEndDate = true;
      this.instructionsForm.controls['endDate'].setValidators([Validators.required]);
      if (endDate && !this.checkIfValidDate(endDate)) {
        this.invalidEndDateFormatMsg();
      }
      this.setValidationsOnDateFields();
    }
  }

  private enableDisableAmountType(transactionType: string): void {
    if (transactionType === TransactionTypeValues.Buy) {
      this.instructionsForm.controls.amountType.setValue('Dollars');
      this.checkAmountType(false);
      this.validateAmountField(this.instructionsForm.controls.amountType.value);
    } else {
      this.checkAmountType(true);
    }
  }

  private stopInstruction(instruction: CreateEditInstructionsModel): void {
    const stopInstructionData: CreateEditInstructionsModel = Object.assign({}, instruction);
    stopInstructionData.endDate = this.getDateInBackendFormat(Date.now());
    stopInstructionData.startDate = this.getDateInBackendFormat(new Date(instruction.startDate));
    if (stopInstructionData.restartDate) {
      stopInstructionData.restartDate = null;
    }
    stopInstructionData.isUpdate = true;
    if (stopInstructionData.isRestarted) {
      stopInstructionData.restartDate = null;
      this.instructionsData.isRestarted = false;
    }
    this.showSpinner();

    this.mfInvestingService.validateInstruction(instruction).subscribe(
      (response) => {
        var errorFound = false;
        var errorMsg = '';
        const validationMsgArr = response.data?.attributes?.validateInstructionDetails.validateInstructionMessages;

        for (var i = 0; i < validationMsgArr.length; i++) {
          if (validationMsgArr[i].messageId == 7415) {
            errorFound = true;
            errorMsg = validationMsgArr[i].editMessageText;
          }
        }

        if (errorFound) {
          this.mfInvestingService.showHideInstructionNotification({
            notificationType: 'error',
            messages: [errorMsg],
            isHardEdit: true
          });
          this.hideSpinner();
        } else {
          this.mfInvestingService.createUpdateInstruction(stopInstructionData).subscribe(
            (response) => {
              if (response.data.attributes.createdSuccesfullyInd) {
                this.isCancelOrStopInstructionNow = true;
                stopInstructionData.status = statusConstants.stopped;
                this.mfInvestingService.updateInstructionStatus(stopInstructionData);
                this.hideSpinner();
                this.mfInvestingService.showHideInstructionNotification({
                  notificationType: 'confirmation',
                  messages: [messageConstants.successfullyStopped]
                });
              } else {
                this.mfInvestingService.showHideInstructionNotification({
                  notificationType: 'error',
                  messages: [messageConstants.errorCancelingStopping]
                });
                this.hideSpinner();
              }
            },
            (error) => {
              this.mfInvestingService.showHideInstructionNotification({
                notificationType: 'error',
                messages: [messageConstants.errorCancelingStopping]
              });
              this.hideSpinner();
            }
          );
        }
      },
      (error) => {
        this.mfInvestingService.showHideInstructionNotification({
          notificationType: 'error',
          messages: [messageConstants.errorCancelingStopping]
        });
        this.hideSpinner();
      }
    );
  }

  private deleteInstruction(instruction: CreateEditInstructionsModel): void {
    const deleteInstructionData: CreateEditInstructionsModel = Object.assign({}, instruction);
    if (instruction.endDate) {
      deleteInstructionData.endDate = this.getDateInBackendFormat(new Date(instruction.endDate));
    } else {
      deleteInstructionData.endDate = '';
    }
    deleteInstructionData.startDate = this.getDateInBackendFormat(new Date(instruction.startDate));
    deleteInstructionData.isUpdate = false;
    deleteInstructionData.isDelete = true;
    this.showSpinner();

    this.mfInvestingService.validateInstruction(deleteInstructionData).subscribe(
      (response) => {
        var errorFound = false;
        var errorMsg = '';
        const validationMsgArr = response.data?.attributes?.validateInstructionDetails.validateInstructionMessages;

        for (var i = 0; i < validationMsgArr.length; i++) {
          if (validationMsgArr[i].messageId == 7415) {
            errorFound = true;
            errorMsg = validationMsgArr[i].editMessageText;
          }
        }

        if (errorFound) {
          this.mfInvestingService.showHideInstructionNotification({
            notificationType: 'error',
            messages: [errorMsg],
            isHardEdit: true
          });
          this.hideSpinner();
        } else {
          this.mfInvestingService.createUpdateInstruction(deleteInstructionData).subscribe(
            (response) => {
              if (response.data.attributes.createdSuccesfullyInd) {
                this.isCancelOrStopInstructionNow = true;
                deleteInstructionData.status = statusConstants.cancelled;
                this.mfInvestingService.updateInstructionStatus(deleteInstructionData);
                this.hideSpinner();
                this.mfInvestingService.showHideInstructionNotification({
                  notificationType: 'confirmation',
                  messages: [messageConstants.successfullyCanceled]
                });
              } else {
                this.mfInvestingService.showHideInstructionNotification({
                  notificationType: 'error',
                  messages: [messageConstants.errorCancelingStopping]
                });
                this.hideSpinner();
              }
            },
            (error) => {
              this.mfInvestingService.showHideInstructionNotification({
                notificationType: 'error',
                messages: [messageConstants.errorCancelingStopping]
              });
              this.hideSpinner();
            }
          );
        }
      },
      (error) => {
        this.mfInvestingService.showHideInstructionNotification({
          notificationType: 'error',
          messages: [messageConstants.errorCancelingStopping]
        });
        this.hideSpinner();
      }
    );
  }

  private getDateInBackendFormat(date: any): string {
    const momentDate = moment(date);
    const month = momentDate.format('MM');
    const day = momentDate.format('DD');
    const year = momentDate.format('YYYY');
    return year + month + day;
  }

  private populateInstructionsForm(instructions: CreateEditInstructionsModel): void {
    this.instructionsForm.patchValue({
      account: this.selectedAccount ? this.selectedAccount : instructions.account,
      transactionType: instructions.transactionType,
      amountType: instructions.amountType,
      amount: instructions.amount,
      frequency: instructions.frequency,
      symbol: this.selectedSymbol ? this.selectedSymbol : instructions.symbol,
      startDate: instructions.startDate,
      duration: instructions.duration,
      endDate: instructions.endDate && instructions.endDate !== '0' ? instructions.endDate : null,
      accountControlNumber: instructions.accountControlNumber,
      discretionaryInd: instructions.discretionaryInd,
      solicitedInd: instructions.solicitedInd,
      itemIssueId: instructions.itemIssueId,
      status: instructions.status ? instructions.status : '',
      restartDate: instructions.restartDate ? instructions.restartDate : null,
      instructionContext: instructions.instructionContext,
      clndAuditIntgCntlNr: instructions.clndAuditIntgCntlNr,
      dayToExecute: instructions.dayToExecute,
      dayToExecute2: instructions.dayToExecute2 ? instructions.dayToExecute2 : null
    });
    setTimeout(() => {
      this.populateDatesForEditInstructions(instructions);
      this.populateSelections(instructions);
      const transactionType = document.getElementsByName('transactionType')[0] as HTMLSelectElement;
      if (instructions.transactionType === TransactionTypeValues.Sell) {
        transactionType.value = instructions.transactionType;
      }
      const amountType = document.getElementsByName('amountType')[0] as HTMLSelectElement;
      if (amountType && instructions.transactionType === TransactionTypeValues.Buy) {
        amountType.disabled = true;
      }
      if (
        instructions.duration === DurationValues.runUntilStopped ||
        this.restartDateExistsAndStopDateIsBeforeRestartDate(instructions)
      ) {
        this.isDurationRunUntilStopped = true;
      } else if (instructions.duration === DurationValues.stopOnSelectedDate) {
        this.isDurationStopOnSelectedDate = true;
      }

      if (instructions.status === statusConstants.active) {
        const startDate = document.getElementById('calendar-startDate') as HTMLInputElement;
        const startDateButton = document.getElementById('calendarIcon-startDate') as HTMLButtonElement;
        if(startDate) {
          startDate.disabled = true;
        }
        if(startDateButton) {
          startDateButton.disabled = true;
          this.isStartDateButtonDisabled = true;
        }
        if (this.startDateHasError) {
          this.startDateErrorMessage = '';
          this.startDateHasError = false;
        }
        this.updateDurationFields(false);
      }
      if (instructions.status === statusConstants.stopped || instructions.status === statusConstants.restarted) {
        this.stopDateLabel = 'Original stop date';
        const startDate = document.getElementById('calendar-startDate') as HTMLInputElement;
        if (instructions.restartDate) {
          startDate.value = instructions.restartDate;
          if (this.startDateHasError) {
            this.startDateErrorMessage = '';
            this.startDateHasError = false;
          }
        } else {
          startDate.value = null;
        }
        this.updateDurationFields(true);
        this.endDateErrorMessage = '';
        this.endDateHasError = false;
        this.startAtDate = moment().add(1, 'days').toDate();
      } else {
        this.stopDateLabel = 'Stop date';
      }
      if (instructions.frequency === FrequencyValues[2]) {
        this.disablePreviousDays();
      }
    }, 100);
    this.showHideEndDate(instructions.duration, instructions.endDate);
    this.validateStartDate(this.instructionsData.startDate);
    if (!this.existingInstruction) {
      this.existingInstruction = this.instructionsForm.value;
    }
  }

  private restartDateExistsAndStopDateIsBeforeRestartDate(instructionData: CreateEditInstructionsModel): boolean {
    if (instructionData.restartDate) {
      if (
        moment(moment(instructionData.endDate, 'MM/DD/YYYY')).isBefore(
          moment(instructionData.restartDate, 'MM/DD/YYYY'),
          'day'
        )
      ) {
        return true;
      }
    }
    return false;
  }

  updateDurationFields(checkStatus: boolean): void {
    const runUntilStoppedRadio = document.getElementById('run-until-stopped-radio-id') as HTMLInputElement;
    runUntilStoppedRadio.disabled = checkStatus;
    const endDate = document.getElementById('calendar-endDate') as HTMLInputElement;
    const endDateButton = document.getElementById('calendarIcon-endDate') as HTMLInputElement;
    if (endDate) {
      endDate.disabled = checkStatus;
    }
    if (endDateButton) {
      endDateButton.disabled = checkStatus;
      this.isEndDateButtonDisabled = checkStatus;
    }
    const enterStoppedRadio = document.getElementById('stop-date-radio-id') as HTMLInputElement;
    enterStoppedRadio.disabled = checkStatus;
  }

  private populateAndDisableAccountSymbolFields(instruction: CreateEditInstructionsModel): void {
    const parentElement = document.getElementById('create-edit-instructions-container') as HTMLElement;
    const accountInput = parentElement.getElementsByClassName('client-search')[0] as HTMLInputElement;
    const symbolInput = parentElement.getElementsByClassName('client-search')[1] as HTMLInputElement;

    if (accountInput && symbolInput) {
      this.accountSearchService.search({ searchTerm: instruction.account, isMaster: false }).subscribe(
        (response) => {
          response.data.map((r) => {
            this.setAccountField(r.attributes);
          });
        },
        (error) => {}
      );

      this.symbolSearchService
        .getAvailableFundsForAccount({ accountId: instruction.account, itemIssueId: parseInt(instruction.itemIssueId, 10) })
        .subscribe(
          (response) => {
            const symbolRecord: SymbolRecord = response?.data?.attributes.elgibleInstructions[0];
            symbolRecord.accountControlNumber = response?.data?.attributes.accountControlNumber;
            this.instructionsData.discretionaryInd = symbolRecord.discretionaryInd;
            this.instructionsData.solicitedInd = symbolRecord.solicitedInd;
            this.symbolSelected(symbolRecord);
          },
          (error) => {}
        );

      if (this.selectedAccountWithName) {
        accountInput.value = this.selectedAccountWithName;
        symbolInput.value = this.selectedSymbol;
      } else {
        accountInput.value = '';
        symbolInput.value = '';
      }
      accountInput.disabled = true;
      symbolInput.disabled = true;
      this.populateInstructionsForm(this.instructionsData);
    }
  }

  private setAccountField(account: AccountRecord): void {
    if (account) {
      let transformedAccountNumber = this.accountNumberPipe.transform(account.accountId);
      this.selectedAccount = account.accountId;
      if (account.accountName) {
        transformedAccountNumber = transformedAccountNumber + '  ' + account.accountName;
      }
      if (account.type) {
        transformedAccountNumber = transformedAccountNumber + ' - ' + account.type;
      }
      this.selectedAccountWithName = transformedAccountNumber;
      this.selectedAccountType = account.type;
      this.selectedAccountName = account.accountName;
      this.selectedAccountDescription = account.titleLine2 + ' ' + account.titleLine3;
      this.instructionsForm.controls.account.setValue(account.accountId);
      this.instructionsForm.controls.accountName.setValue(account.accountName);
      this.instructionsForm.controls.accountDescription.setValue(account.titleLine2 + ' ' + account.titleLine3);
      this.instructionsForm.controls.accountType.setValue(account.type);
      this.accountHasError = false;
      this.accountErrorMessage = '';
    } else {
      this.selectedAccountWithName = null;
      this.selectedAccount = null;
      this.instructionsForm.controls.account.setValue(null);
    }
  }

  private validateInstruction(): void {
    const instructionToValidate = this.prepareInstructionData();
    this.mfInvestingService.validateInstruction(instructionToValidate).subscribe(
      (response: IValidateInstructionResponse) => {
        const validationMsgArr = response.data?.attributes?.validateInstructionDetails.validateInstructionMessages;
        this.transactionFee = response.data?.attributes?.validateInstructionDetails.transactionFee;
        if (validationMsgArr && validationMsgArr.length > 0) {
          const hardEditMsgArray = validationMsgArr.filter((i) => i.isHardEdit).map((i) => i.editMessageText);
          const softEditMsgArray = validationMsgArr.filter((i) => !i.isHardEdit).map((i) => i.editMessageText);
          if (hardEditMsgArray && hardEditMsgArray.length > 0) {
            this.mfInvestingService.showHideInstructionNotification({
              notificationHeading: messageConstants.hardEditNotificationHeading,
              notificationType: 'error',
              messages: hardEditMsgArray,
              isHardEdit: true
            });
          } else if (softEditMsgArray && softEditMsgArray.length > 0) {
            setTimeout(() => {
              this.previewInstructionsComponent.loadInstructionData();
            }, 100);
            this.viewMode = CreateEditInstructionsViewMode.PREVIEW_INSTRUCTION;
            this.clearInstructionAlreadyExistsNotificationBanner();
            this.mfInvestingService.showHideInstructionNotification({
              notificationHeading: messageConstants.softEditNotificationHeading,
              notificationType: 'warning',
              messages: softEditMsgArray
            });
          }
        } else {
          setTimeout(() => {
            this.previewInstructionsComponent.loadInstructionData();
          }, 100);
          this.viewMode = CreateEditInstructionsViewMode.PREVIEW_INSTRUCTION;
          this.instructionNotificationComponent.clearNotification();
        }
        this.hideSpinner();
      },
      (error) => {
        this.mfInvestingService.showHideInstructionNotification({
          notificationType: 'error',
          messages: [messageConstants.errorCreatingUpdating]
        });
        this.hideSpinner();
      }
    );
  }

  private updateDayToExecute(startDate: string): void {
    const frequency = this.instructionsForm.controls.frequency.value;
    const dayOne = this.instructionsForm.controls.dayToExecute.value;

    if (
      startDate &&
      frequency &&
      dayOne === null &&
      (this.instructionsForm.controls.status.value === null ||
        this.instructionsForm.controls.status.value === '' ||
        this.instructionsForm.controls.status.value === statusConstants.stopped)
    ) {
      if (frequency === FrequencyValues[0] || frequency === FrequencyValues[1]) {
        this.instructionsForm.controls.dayToExecute.setValue(
          moment().isoWeekday(moment(startDate, 'MM/DD/YYYY').day()).format('dddd')
        );
      } else {
        this.instructionsForm.controls.dayToExecute.setValue(moment(startDate, 'MM/DD/YYYY').format('Do'));
      }
    }
    setTimeout(() => {
      this.updateSecondDayToExecute();
    }, 100);
  }

  private updateSecondDayToExecute(): void {
    const frequency = this.instructionsForm.controls.frequency.value;
    if (frequency === FrequencyValues[2]) {
      this.disablePreviousDays();
    } else {
      this.instructionsForm.controls.dayToExecute2.setValue(null);
      this.dayToExecuteHasError = false;
      this.dayToExecuteErrorMessage = '';
    }
    this.clearHardEditNotificationBanner();
  }

  private disablePreviousDays(): void {
    const dayOne = this.instructionsForm.controls.dayToExecute.value;
    const dayTwoSelect = document.getElementById('day-two') as HTMLSelectElement;

    if (dayOne === this.daysSource[30]) {
      this.dayToExecuteErrorMessage = 'The 2nd day must be after the 1st. Please change the 1st.';
      this.dayToExecuteHasError = true;
      dayTwoSelect.disabled = true;
      dayTwoSelect.value = '';
    } else {
      const dayOneIndex = this.daysSource.findIndex((x) => x === dayOne);
      const dayTwoIndex = this.daysSource.findIndex((x) => x === dayTwoSelect.value);
      this.dayToExecuteErrorMessage = '';
      this.dayToExecuteHasError = false;
      dayTwoSelect.disabled = false;

      for (let i = 0; i < dayOneIndex + 1; i++) {
        dayTwoSelect[i].disabled = true;
      }
      for (let i = dayOneIndex + 1; i < this.daysSource.length; i++) {
        dayTwoSelect[i].disabled = false;
      }

      if (dayTwoIndex <= dayOneIndex) {
        this.instructionsForm.controls.dayToExecute2.setValue(null);
      }
    }
  }

  private populateSelections(instructions: CreateEditInstructionsModel): void {
    const discretionaryCheckbox = document.getElementById('sdps-discretionary-checkbox-id') as HTMLInputElement;
    const solicitedCheckbox = document.getElementById('sdps-solicited-checkbox-id') as HTMLInputElement;
    if (discretionaryCheckbox) {
      discretionaryCheckbox.checked = instructions.discretionaryInd;
      this.instructionsForm.controls.discretionaryInd.setValue(instructions.discretionaryInd);
    }
    if (solicitedCheckbox) {
      solicitedCheckbox.checked = instructions.solicitedInd;
      this.instructionsForm.controls.solicitedInd.setValue(instructions.solicitedInd);
    }
  }

  private clearHardEditNotificationBanner(): void {
    this.isError = false;
    this.mfInvestingService.clearHardEditNotification();
  }

  private clearInstructionAlreadyExistsNotificationBanner(): void {
    this.mfInvestingService.clearInstructionAlreadyExistsNotification();
  }

  private clearDayToExecuteBasedOnFrequency(frequency: string): void {
    const dayOne = this.instructionsForm.controls.dayToExecute;
    if (
      (this.daysSource.find((x) => x === dayOne.value) &&
        (frequency === FrequencyValues[0] || frequency === FrequencyValues[1])) ||
      (moment.weekdays().find((x) => x === dayOne.value) &&
        (frequency === FrequencyValues[2] ||
          frequency === FrequencyValues[3] ||
          frequency === FrequencyValues[4] ||
          frequency === FrequencyValues[5] ||
          frequency === FrequencyValues[6]))
    ) {
      dayOne.setValue(null);
    }
  }

  isEmployeeAccount(): boolean {
    return this.integrationService.getIsEmployee();
  }

  printButtonClick() {
    const currDt = new Date();
    const timeStamp =
      currDt.getMonth() + 1 + '/' + currDt.getDate() + '/' + currDt.getFullYear() + ' ' + currDt.toLocaleTimeString();
    this.previewContainer = document.getElementById('preview-instructions') as HTMLElement;
    const successMessage = document.getElementById('warning notification') as HTMLElement;
    this.printWindow = window.open('', '_blank', 'left=350,top=200,width=auto,height=auto');
    this.printWindow.resizeTo(window.innerWidth * 0.5, window.innerHeight * 0.8);
    if (this.printWindow) {
      this.printWindow.document.open();
      this.printWindow.document.write(
        '<html><head><title>Automatic Mutual Fund Investing ' +
          timeStamp +
          '</title>' +
          '<style>#cs-image {' +
          'width: 40px;height: 40px;background-size: contain;}' +
          '#print {position: absolute;float: right;top: 8px;right: 8px;width: calc(100% - 70px);height: 40px;display: flex;justify-content: space-between;}' +
          '#print span {font-weight: bold;font-size: 15px;line-height: 40px;height: inherit;display: flex;vertical-align: middle;align-content: center;flex-wrap: wrap;}' +
          '#print #print-button {background-color: green;border: none;border-radius: 5px;width: 75px;height: 30px;color: white;padding: 5px 15px;cursor: pointer;}' +
          '#context-id, #context-description {display: inline-table;};#context-id {padding-right: 20px;}hr {border-style: solid;}' +
          '.flex-container {margin: 5px;padding: 20px;box-sizing: border-box;border: 1px solid #B7B7B7;}.flex-row-base {display: flex;flex-direction: row;flex: 3;}' +
          '.sdps-grid-container {margin: 0 12px;}.sdps-messaging--confirmation{background-color: #ecf9ec;border-color: #267326;}' +
          '.sdps-messaging {border-width: 1px;border-width: 0.0625rem;border-style: solid;color: #000;display: flex;font-family: Arial,Helvetica,sans-serif;font-size: 16px;font-size: 1rem;line-height: 24px;line-height: 1.5rem;margin-top: 16px;margin-top: 1rem;margin-bottom: 16px;margin-bottom: 1rem;position: relative;}' +
          '.sdps-messaging__text {flex-grow: 1;margin: 16px;margin: 1rem;}' +
          '.flex-row {display: flex;flex-direction: row;flex-wrap: wrap;width: 100%;padding-bottom: 12px;}.flex-col-left, .flex-col-middle {display: flex;flex-direction: column;flex: 3;}.flex-col {display: flex;flex-direction: column;flex: 2;}.preview-label {text-align: right;padding-right: 12px;height: 20px;color: #4C5561;font-family: Arial, sans-serif;font-size: 13px;letter-spacing: 0.08px;line-height: 20px;}.note {color: #999;}</style></head>' +
          "<body><div><img id='cs-image' src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAARQklEQVR4Xu2deZAV1RXGnwoIChHjghJBUBBD1JKowVTUUsF9KRMTtRKXqIiGxLJMqSGWGgURN1AWDVtQkE1RIyiIgLIIgoDIJszCOqzDMsO+DXDz/U73HXrePOaN9JC/+lSd6nndt+895zvrvU0VqdS7ywrEmxM+LC4AwANil/Bh8QEABMlMDxPOzpsTAONxAmBMTgCMyQmAMTkBMCYnAMbkBMCYnAAYkxMAY3ICYExOAIzJCYAxOQEwJicAxuQEwJicABiTEwBjchUDOEDcf6lL9YvwO+JMY48Ul1s/w5iq4yoGsP8yV2fwCnfqsAJXa9Byd7z4GEDNNPZIsMBi/ZOGrrD14aOP7PpVDGDPfHfn5PVuxfYSt2RbiVsqfmLmJpd6K/9Ie0LAvRe7NtM22rqsjxzt9Dv1ttbPND4+VzGA/1nqTnxvubtj4nrn6c9TNrhUjyOmQFlW+NbT+qzp6aqx6wIDZhofn49ADuye58797yq3/4BzxXv2u+MURpaLMo2vamb9N3LdDePWGXgzNuyWVy4xw2YcH5+rGEDCVOHSY9EWU6Bf3jb9Xvz/CV9YOTj178VuauFuW/+RaUofMmjGsVXDVQygPK2mQmjj7v2mQOuxay0vZhybjammPxZ4GevnI1bb2nsUAieomJgHZhpbNXyYAPaVUHgWuQ0mx6CwwLrpy0JTYINAtNDpIQ/w4wjl9KrIb96V59g8nntpjT5insPm3eGarC9D2RUDcY+xeq/rwsD7By+R9zOPNwJzIA9zcJ/3uHIv0xp+zoG6F5W3LP8IAL0AColj9fthVbfxa3e5kQU73H1fq1CgjJ71z99qCrT/rsilXs1xV3+xzg1YvM31VFgfP0ge0VdzROcMgbt01BrXaf5m12neZnfz+HXug2Xb3aPTFYKAHgJ1i4zTXQD98tM1LvVmnjtaczwzu9gNXbrd/Vrvo/DG3fts/VYUD0Dw4LCOwLlJcw9fscNNkOx/kQ5HIYfvHVljfKF7J3+b65Wz1XK5re3lLc+VBBABQgvfO2m9W79rn1u0da97Ly8AC3pwqkCUEDtKDrid+w4YWB3mFIdPA+om5c3Cfk7NV3/IClMmZ2uJ6ygwxq7eFY527rOVOwSCPFiG6SJwPT04VYq/tdit3hGABb0thZt/EoTvcrUwgFtaPLrnuyYfFLiv1uxy2yTfv74tcm9pPPTGD5IJbxTAvcN7nkYW7HSpbhXm0EoAiKLKIzUkzJAl223iKaputUjYr+W4Kz5f48h4HQXWlV+stefvy3t65wbC9JCAX6zeaX/P3rjnYE5SsTn3o1Vuu8Beon7tVKq15qMQbJWS0M3yuGO65ro+KkZ5GtNfngHhRSPX7HSTVSxafLzKvSMPv+LztW6YPBF67nt5P6Cwjq6t9Gzz3iAvN36/wKXaz3X1BSg0a6Mq9Rt57qlZRW5B8V53wYcr3QNyhoGa80ZVc3rLMniU5UoAiGtrkhHyBmjGJoHQR5MSEjzX9QztPKpp3KhVAVAIAt2KAM/OV18Y5MVB5KVeek8gVle+oc3ZoJAzUPFMgdr045VOmLoiPUv1W+IaSaH5mq+mDNj2m43m3YNlyHxFgMlAmHbJdWcMX2lrQE0Fqq0jL71kZOCV0EWEvjz6T+pTd7GI6HrJWEOyQ/dPUdOttGO5Ue+aXDhQOiYHuRIAyoUfm7HJFihRZWuABbFudGL1XlS8KLUeI/DwKAkzfHngGY+wK0A4KY3XQFRNQszm031yJfSqQpZ1qqtYVGcN5Tz6ut2SYf2u/e6izwSGb1H0rOPcIF1MLtwVKC4j19KzgkiYL9q81zwe+k7R0HqMugSBf7XyJTReIW7yEfqV6wCyACjPO1E5CqtDL86VUgKrzBgUF8hPzCyyMdCTFBDGyUNOl2fspasWNcIzuuS4Zp+sst+fy2NLQZDgDeRtYfS68+Q55pUoIq+pH5lnoDzQchPP5KUcWCzdFnj9fX7nI/CfD0ElLz+svPnkt5tcG13PQQ5ABiwxBcfTQ9P0vg//7JwFQE30qBaFqG7WVxEa0TGEuCrV/KJAgW/WK6cQWlRbgfP894ESX2JdBJPivcL8eBUewD0srpAZtSpIE9NtB6E5qI4YSGMoHBChd6aAtv1t+KyVKj20RXmu7mDJqHUpYr4ffTrsCMxYrAd43sO0dg2t84O8Eyo5cMA1VH7Mkvs8ZwFQliTfQO8qgZtlWRjBUQ4wJdBlAsJTi0/lOQgpUGuqh6JiQ61UYFKdFrpjFZIoildwWmJzKIm3nR4ABNn+WZ5qa8HqAKasD6rzawtUNfE+5OOZZPIFi3YmpaKD918Xbud2C/DTSTs+Z8OsieHRg9/ydOQO64xaqeJAVz/+0JwdwBHq86Cn1WJYThsopbGOBPjNaOUhWdNXR3JdKciyNr0i9LWqJUdML6tS3zkp2OhPM0/V2JcXuWsiBigU4Lz/gtYDBMDwIU8In6KCZQCgvICtIYNQiCCKR2N5z1MzN7nHw7y9XNXbwKIN4yrjtlTPaD0ehvbASt4HQi+3YkcRQY90TMpydgB75QbgjCFfYXmBWEN5B2Dnbdnr6gwpsIoJXYj3sbBakaMk8Ey1CNAQeUaOxg5Qe0NrAs0r3uPqao17JwS/5xbtsSte1FG5FjoTsOSdz4VpAE+zvtDLpzCmikKbFK6t5eVI0l7jr1erA7Glu4am+pVFZuwOs4NczXt91JfacRd6dV5oBoDuVK9r+dGvc2jOAqCsc6mqnafR6uf6qzoi1Fp5ylmyfhu1FlCOcohZmdDW4hfLylEap2aZ8Go+IhAS8kXhUVne50pPl1CdpVgNeVpJGFrnqMUpE4ryoGjxgvqSat7MdccrUkgTnsau3GmG5ta16guJIk991EC3F5C0VQPxPq9HFIvMnAVAXFgC/05e4j2kUIt0W7TV1SaU1T5QZCYKnBtl8dICo2szhQhewaEm4WRCKdfUlHeyTdqqhJOnXu4uhTQJnupJsztOO5Hz1WCbJyvkTpIXUoDYwtkcUfnkUWd/tNIt1i6GXclf2fpRuanMevYrRQSyYQCgZEtZn0JIMdHz274qdHPU10ILFCF2esMePJofK+YsADIJICKUfp+gluYo7oVFIjVAIGIpOF053autIsHpjFVMhAJ0Kq7GnkC1ZG5Chff1t91jHF4WVYB7zJ+ekxgjsGpo3lq2jt5jLu7DzKPfzFudtVlLwJXOHepVV3rZby9LdO2KOQuAUfZKcI0qwoKHajwBGY4+Qzje8XOl32MuP9Yz93ieft9zpnU8hwY75POoXunPsnMlAEQ5FiY8sRiMFdOFYRxCYHU/zsaKGYsivBdlb22Ui973CkXvwX486/Gcef3v9Dn8M95B9ui7UXmj73hmLj+uYq5ECKO4QvC8T1a7dsp3d6lCnUZf5T2FMXy6JKx1j2MlCsvfNPZaVb965Bzd/5l2ElS5nyic2N00V46sTchKsbN1v6Ge86yecl4T/WZv21gNM2mDEGN8HUKNtWDWh0NDNlYuZN/M3LQofJ2zE2o9r4e8Ub1grdtI75BDWZcvibRLzFGN1GThrHFR0MtzFgCxmjyqk7ZEO1W+emufOlvtB82p9VE+5NTu/FZtwVwl5FwVBo6F+qnl2LQ3qILnSbBLldBJ2KuU7Nfu3GcnNoCFlz6oAkIh4FmBis4zajUu1lbuKxWADar2azSezwOnDNX4cM2RqqoUAZ9f75q43s3S/pYmfdjyHe5kwFYVx6Dcu4S9MxHhdVOxuHV8octV98C6FMmhKjIr9PeybSW2/7e1wCCKSVnOAqAq4f3hF667J6s3ep0ecKm1Ax0EKlUYgDvPCfq2D1fscLV5D0HlkQ20naI16KmqnXpJDXN43LVNCtUZLCsjIB6kqtgp7P0A7WisL/5FeDwPna/2x7xC6zUPG2uOyUobXj0bpF0TW7E6nCKzlZQMnPdBL80LDie8xxprXSo3NE5zHSfAW8pwvv25hc6C+f348pwFwO75dtgJNaW1EIB4GyfDv58gQLXd8o3xwmL1gbQA5ECEhLWL+KNC/mVOVtSAE0oQpyKWf2BCRIK3CXcBdhSPYfBsgeJ3QnaSAwBS+tmwGUbRU/FK1lXuWqh5X2EtGmPNzVZxkwwI4cX2kZ81vX4980r30cPltXYAoob79RD0TvPUOkUb9/KcHcD3NTFEeDRVXrIJWShMzN+FfVTbb9TPIXh6ztAYayE0/izlG2jRFm2v8CaA4irvvHty4Okc5dt20NY/COykdeFRk7wWL/V0L/tmNejkzO1q+FoQqhhRspOH5xbtdbNCGW1HwtxeRs13a+gAto/u8IPd46seB1AtaObRM6pPWc4CoARpOfLgjqJETEN7OrlLyiN04OzOXTZa3T0Kps9BDsGbVI1J2Gw+aKK7ysqvyVu4dtIuxIMyLAqgPIuCAqFQdSneSJFA/vyH9sqQAavIaDd9o20XLS3QSEtx9uCtBRrRAvG9xmT0/14nAuA85cDnlfcK5KnIyHeZVFdFXFSX8pwFQMJQ+exyJWJvRci2ccNWuDPCY3GoZXqSTp9HCgEg6YUcSk7qNKfYPiJ1nFVUeuxfBkDAV0sxU94Psdf++4wiO3QlFJXujOrIw9+UIXrzHVpey1qcJ1KAGg4vsMMDiJC3Sg7IzB8BcLb0e0yFaJSKE8Tuh8Jn3hzVpSxXACBujgK4MLlHJf0RtSdF4RnbkOXb7SSECgfdru1eqeLpc9BbaZ4mYQiTq0xRjp64vrjQqihUJoRhKckXPogPQR8qpdzNV0B5nc+PnRdstvt2Sm3hm+c6yzDQrA277SQbD4ZIFbZmOLcHcDAh3FEh3CW39GPYSlXk4xgX/ZJYlisAUBZuoBC9nWJB4qW5lND+nM2OiRSanCpD75H806ucnrP1uweFNQfnclC+Whb7nOgTugDjEyZUDkB59YWfHkwjszfuDvo0pZAb1IZ4+nKNKjKehcEVongfnzzra476kumfoRHGUrmJFAwrAG8O5/hIHYStq7aIPtfTueTBQ3thBQBKEJpTWrnLyW8UDlgLQ7OVMzj14ButJxpROwj1Hb0q77NSwqqu7nNKDNlvFEVhvPT1XHdPWETY8NvpsZcDRWUIf2KMF5oHaf4aek46gV6Q11gRkwfdocpP32pGDys3hvTRUpcczhySn1NxyFIH676SY/pCxRpfG/kOvTOpAEC6cFmI8g+1Vh45W5NxMg3dSEVDOFmz3dSD/xrqoUkbXBN2E8o1j4enzO3VdpzcLdc9EzmywvLV8UAB1Ew7Ae/JS9SIXyjPr4YM3pu1Tt/wGzRth62LYgKBz4+QNcq6fwFGF070nw2Up62AyVB8Ns1TkYHItw3VK56mZwMXByfubA445nooTCV8vLoFHYVBOWwOcpYiIi+5QsB9psS6QB7A0dBEVb3rmBgPYkwI9Pmqlu9KmYUScrwEhPkcicfwdew25cgJepd/yTBGz8hf9dliqWJSUKjCPEO5PjISW7LSEFcIsS2coqpazZ/ohPevlNJ8MLffus9RG1/m+L5i30JC+drKyKNlJNbgu00btV1/mFhoVdzLxJnlcP3NF8FmMsQhi+JBzgIgVmarpHBhb3kyro9Smbpz8oTG8i9Cf6r9L2z3w62WKU44Eg60GfIu/69H7QooPAvBsWMzPzfMu56jzxjPPbyV+1yRUfctz4Zs8/n1deWZrevvmUz6m7RCeOMg6TKU5ywAemYRFogomJG98FH2YcgcvBvlip5F54X93JnuR8dH5+Jv7nmg/H3/LNO6/p3KcSUBTPhQnAAYkxMAY3ICYExOAIzJCYAxOQEwJicAxuQEwJicABiTEwBjcgJgTE4AjMkJgDE5ATAmJwDG5ATAmJwAGJMTAGNyAmBMTgCMyQZg8p8RHD7bf0aQ/HcYh83LCv4H1pjNTSUXJ08AAAAASUVORK5CYII='/></div><div id='print'><span>Schwab Advisor Center<sup>®</sup></span><span>" +
          "<button id='print-button' onclick='window.print();window.close();'>Print</button></span></div><hr /><div>" +
          successMessage.innerHTML +
          '</div>' +
          "<div style='padding-left: 1.5rem;line-height: 2rem;font-family: CharlesModern-Regular,Arial,Helvetica,sans-serif;font-weight: 400;'>Automatic Mutual Fund Investing</div><div>" +
          this.previewContainer.innerHTML +
          '</div>' +
          "<div style='position: absolute;bottom: 0;width: auto;border-top: 1px solid #CCCCCC;text-align:left;font-size:11px;padding:5px;'>" +
          '&#169;' +
          currDt.getFullYear() +
          ' Charles Schwab & Co., Inc. ("Schwab"). All rights reserved. Member SIPC.\n' +
          'Schwab Advisor Services<sup>&#8482;</sup> (formerly known as Schwab Institutional<sup>&reg;</sup>) serves independent investment advisors and includes the custody, trading and support services of Schwab.\n' +
          'This material is for institutional investor use only. This material may not be forwarded or made available, in part or in whole, to any party that is not an institutional investor.</div></body></html>'
      );
    }
  }
}
